import { gql } from '@apollo/client';

export default gql`
  query freeUpgradeJourneySearch($exchangeItems: [Int!], $reference: String!, $currency: String!) {
    freeUpgradeJourneySearch(exchangeItems: $exchangeItems, reference: $reference, currency: $currency) {
      outbound {
        ...exchangeOffer
      }
      inbound {
        ...exchangeOffer
      }
      passengers {
        id
        disabilityType
        type
      }
    }
  }

  fragment exchangeOffer on Offer {
    journeys {
      fares {
        productCode
        legs {
          origin {
            uic
          }
          destination {
            uic
          }
          serviceName
          serviceIdentifier
          timing {
            departureDate
            departs
            arrives
            duration
          }
          products {
            passengerId
            tariffCode
            price
          }
        }
        fees {
          tariffCode
          price
          name
          passengerId
          code
        }
        productFamily {
          code
          name
          familyGroup
        }
        classOfService {
          code
          name
        }
        prices {
          displayPrice
        }
        bookingItems {
          passengerId
          tariffCode
          price
        }
      }
    }
  }
`;
